package net.maraclinic.app

import androidx.compose.runtime.Composable
import net.maraclinic.app.pages.LandingPage
import net.maraclinic.app.styles.AppStyleSheet
import net.maraclinic.app.styles.ComponentsStyleSheet
import net.maraclinic.app.styles.LandingPageStyleSheet
import org.jetbrains.compose.web.css.Style
import org.jetbrains.compose.web.dom.Main
import org.jetbrains.compose.web.renderComposableInBody

fun main() {
    renderComposableInBody { App() }
}

@Composable
private fun App() {
    Styles.forEach { Style(it) }
    Main(attrs = { classes(AppStyleSheet.Main) }) {
        LandingPage()
    }
}

private val Styles = listOf(
    AppStyleSheet,
    ComponentsStyleSheet,
    LandingPageStyleSheet,
)